import Layout from '@comp/layout'
import SolutionMeta from '@comp/solution/solution-meta'
import PressHero from '@comp/press/press-hero'
import AboutBoilerplate from '@comp/press/about-boilerplate'
import LogoGallery from '@comp/press/logo-gallery'
import ColorPalette from '@comp/press/color-palette'
import TypographyBlock from '@comp/press/typography-block'
import UsageGuidelines from '@comp/press/usage-guidelines'
import MediaInquiry from '@comp/press/media-inquiry'

export default function PressKitPage() {
  return (
    <Layout>
      <SolutionMeta
        title="Press kit & brand guidelines"
        description="Monofor logos, brand colors, typography, usage guidelines, and media contact: everything you need to write about, design with, or report on Monofor."
        path="/press-kit"
      />
      <main className="bg-surface text-ink-primary">
        <PressHero />
        <AboutBoilerplate />
        <LogoGallery />
        <ColorPalette />
        <TypographyBlock />
        <UsageGuidelines />
        <MediaInquiry />
      </main>
    </Layout>
  )
}
